import * as React from 'react'

function SvgRepairSuccesIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        d="m16.354 10.354-.708-.708L11 14.293l-2.646-2.647-.708.708L11 15.707l5.354-5.353Z"
        fill="#F16B0A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8 7a7 7 0 1 1 0-14 7 7 0 0 1 0 14Z"
        fill="#F16B0A"
      />
    </svg>
  )
}

export default SvgRepairSuccesIcon
